<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<todo-form :todo-id="id" />
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import todoForm from '@/components/todos/todo-form';

function closeModal() {
	this.goTo('page-todo');
}

function title() {
	const todo = 'Tarea';
	return this.id ? `Editar ${todo}` : `Crear ${todo}`;
}

export default {
	name: 'page-todo-new',
	components: {
		actionSidebar,
		todoForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/todos/page-todo-new.vue